export const hashObject = (o: object): string => {
  const str = JSON.stringify(
    o,
    Object.keys(o).sort((a, b) => a.localeCompare(b, 'en'))
  );
  let hash = 0;

  for (const ch of str) {
    hash = (hash << 5) - hash + (ch.codePointAt(0) ?? 0);
    hash |= 0; //NOSONAR
  }

  return hash.toString();
};
